/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { connect } from 'store/modules/base/redux/functions';
import {
  getLocalVideoTrack,
  getTrackState
} from 'store/modules/base/tracks/functions';
import Video from '../Video/Video';

/** .
 * Implements a React {@link Component} which represents the large video (a.k.a.
 * The conference participant who is on the local stage) on Web/React.
 *
 * @augments Component
 */
class SelfLargeVideo extends Component {
  /**
   * Constructor of the component.
   *
   * @inheritdoc
   */
  constructor(props) {
    super(props);

    this._containerRef = React.createRef();
    this._wrapperRef = React.createRef();
  }

  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {React$Element}
   */
  render() {
    const { visible, _videoTrack } = this.props;
    const style = this._getCustomStyles();
    return (
      <div
        className="videocontainer"
        id="largeVideoContainer"
        ref={this._containerRef}
        style={{ ...style, display: visible ? 'block' : 'none' }}>
        <div id="largeVideoElementsContainer">
          {/*
           * FIXME: the architecture of elements related to the large
           * video and the naming. The background is not part of
           * largeVideoWrapper because we are controlling the size of
           * the video through largeVideoWrapper. That's why we need
           * another container for the background and the
           * largeVideoWrapper in order to hide/show them.
           */}
          <div id="largeVideoWrapper" ref={this._wrapperRef} role="figure">
            <Video
              autoPlay={true}
              id="selflargevideo"
              muted={false}
              videoTrack={_videoTrack}
            />
            <canvas id="selfcanvas" style={{ zIndex: 2 }} />
          </div>
        </div>
      </div>
    );
  }

  /**
   * Creates the custom styles object.
   *
   * @private
   * @returns {Object}
   */
  _getCustomStyles() {
    const styles = {};

    styles.pointerEvents = 'all !important';
    styles.backgroundColor = interfaceConfig.DEFAULT_BACKGROUND;
    return styles;
  }
}

SelfLargeVideo.propTypes = {
  dispatch: PropTypes.func,
  _videoTrack: PropTypes.any,
  visible: PropTypes.bool
};

/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state, ownProps) {
  const videoTrack = getLocalVideoTrack(getTrackState(state));

  return {
    _videoTrack: videoTrack
  };
}

export default React.memo(
  connect(_mapStateToProps)(withBoundary(SelfLargeVideo))
);
